
import GenreMaker from '../anychart/genreMaker'; 

var BarChart = class BarChart extends GenreMaker {

    setData(state){
        super.setData(state);
        for (var series in this.data) {
            this.chart.bar(this.data[series]);
        }

    }

    createChart(){
        var chart = anychart.bar();
        if(this.ifIncluded("3d")){
            chart = anychart.bar3d();
          
        }
        return chart;
    }; 
};


    
GenreMaker.bar = BarChart;

export var BarChart;



// WEBPACK FOOTER //
// ./src/anychart/barChart.js